<div class="relative w-full">
    <input
      [(ngModel)]="rapidAccessText"
      (input)="onSearchChange()"
      class="w-full border rounded-full bg-white border-[#9e9e9e] p-2 pr-8 placeholder:italic"
      placeholder="Rechercher action et indice"
    />
    <mat-icon
      class="absolute top-1/2 transform -translate-y-1/2 right-2"
      [svgIcon]="'feather:search'"
    />
    <ul
      *ngIf="rapidAccessResult?.length"
      class="rounded-xl absolute w-full top-full bg-white shadow"
    >
      <li
        [routerLink]="[
          '/actifs',
          actif?.referentiel?.stockName,
          actif?.referentiel?.isin,
        ]"
        (click)="rapidAccessResult = []"
        class="p-2 border-b cursor-pointer hover:bg-[#fbfbfb]"
        *ngFor="let actif of rapidAccessResult"
      >
        {{ actif?.referentiel?.stockName }}
      </li>
    </ul>
</div>